import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PagePropsContext } from '../App';
import Autocomplete from './common/Autocomplete';
import { getQuestions } from '../utils/functions';

const Search = () => {
  const { t } = useTranslation();
  const { categories, setSelectedCategory, setSelectedQuestion } = useContext(PagePropsContext);

  const [searchText, setSearchText] = useState('');

  const handleClear = () => {
    setSearchText('');
  }

  const handleChange = async (e, setOptions) => {
    const value = e.target.value;
    setSearchText(value);
    if (value.length < 3) {
      setOptions([]);
      return;
    }

    const questions = await getQuestions(value);
    setOptions(questions.slice(0, 10).map(q => ({
      ...q,
      text: q.question,
    })));
  }

  const handleSelect = (question) => {
    setSearchText('');

    const category = categories.find(c => c.id === question.category);
    category && setSelectedCategory(categories.find(c => c.id === category.parent_category));
    category && setSelectedQuestion(question);
  }

  return <div className='search'>
    {searchText && <i className='icon icon--close' onClick={handleClear} />}
    <i className='icon icon--search' />
    <Autocomplete
      highlightText
      className={'search__autocomplete'}
      value={searchText}
      placeholder={t('search.placeholder')}
      onChange={handleChange}
      onSelect={handleSelect}
    />
  </div>;
}

export default Search;